import { AGS_LOGO_URL } from "@/lib/brand";

const photos = [
  {
    url: "/team/office-vacuum.jpg",
    label: "Office Vacuum & Floors",
    span: "md:col-span-7 md:row-span-2",
    aspect: "aspect-[4/5] md:aspect-auto md:h-full",
  },
  {
    url: "https://images.pexels.com/photos/4099467/pexels-photo-4099467.jpeg",
    label: "Surface Disinfection",
    span: "md:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    url: "/team/floor-care.jpg",
    label: "Industrial Floor Care",
    span: "md:col-span-5",
    aspect: "aspect-[4/3]",
  },
  {
    url: "/team/post-construction-crew.jpg",
    label: "Post-Construction & Builders Cleaning",
    span: "md:col-span-6",
    aspect: "aspect-[4/3]",
  },
  {
    url: "/team/surface-disinfection.jpg",
    label: "Crew Briefing",
    span: "md:col-span-6",
    aspect: "aspect-[4/3]",
  },
];

export default function TeamInAction() {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="bg-[#F4F8FC] py-28 md:py-40 border-t border-[#E5EBF2] relative"
    >
      <div className="relative container-ags">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-16 bg-[#2BB6E5]" />
              <span className="font-mono text-[11px] uppercase tracking-[0.28em] text-[#0E2A57] font-semibold">
                Our Crew · In Action
              </span>
            </div>
            <h2 className="font-heading font-extrabold text-4xl md:text-6xl lg:text-[4.25rem] leading-[0.98] tracking-[-0.038em] text-[#050B14]">
              One trained crew.
              <br />
              <span className="italic-display font-normal text-[#0E2A57]">
                One&nbsp;standard.
              </span>{" "}
              Every site.
            </h2>
          </div>
          <div className="md:max-w-sm">
            <div className="inline-flex items-center gap-3 bg-white border border-[#E5EBF2] px-5 py-3">
              <img
                src={AGS_LOGO_URL}
                alt="AGS logo on team vest"
                className="h-10 w-auto object-contain"
              />
              <div className="leading-tight">
                <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#475569] font-medium">
                  Branded uniform
                </div>
                <div className="text-sm font-bold text-[#0E2A57]">
                  Visible accountability
                </div>
              </div>
            </div>
            <p className="mt-5 text-[#475569] text-sm leading-relaxed">
              Every AGS operative wears our branded navy vest on every job —
              so you always know who's on your premises and who answers for the result.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-5 md:auto-rows-fr">
          {photos.map((p, i) => (
            <figure
              key={p.url}
              data-testid={`team-photo-${i}`}
              className={`group relative overflow-hidden bg-[#0E2A57] ${p.span}`}
            >
              <div className={`${p.aspect} w-full`}>
                <img
                  src={p.url}
                  alt={p.label}
                  loading="lazy"
                  className="w-full h-full object-cover img-mono group-hover:scale-[1.04]"
                />
              </div>
              <div
                aria-hidden
                className="absolute inset-0 bg-gradient-to-t from-[#0E2A57]/85 via-[#0E2A57]/15 to-transparent opacity-90 group-hover:opacity-100 transition-opacity"
              />
              <figcaption className="absolute left-5 bottom-5 right-5 flex items-end justify-between gap-4 text-white">
                <span className="text-[11px] uppercase tracking-[0.22em] font-semibold text-[#BEE7F5]">
                  0{i + 1}
                </span>
                <span className="font-heading font-bold text-base md:text-lg text-right">
                  {p.label}
                </span>
              </figcaption>
              <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-2.5 py-1.5 flex items-center gap-1.5 opacity-0 group-hover:opacity-100 transition-opacity">
                <img
                  src={AGS_LOGO_URL}
                  alt=""
                  className="h-5 w-auto object-contain"
                />
                <span className="text-[10px] font-bold tracking-wider text-[#0E2A57]">
                  AGS
                </span>
              </div>
            </figure>
          ))}
        </div>

      </div>
    </section>
  );
}
